import { render, staticRenderFns } from "./PriceNew.vue?vue&type=template&id=195f5ca0&scoped=true"
import script from "./PriceNew.vue?vue&type=script&lang=js"
export * from "./PriceNew.vue?vue&type=script&lang=js"
import style0 from "./PriceNew.vue?vue&type=style&index=0&id=195f5ca0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f5ca0",
  null
  
)

export default component.exports